// Function to set a cookie
function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

// Function to get a cookie by name
function getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return '';
}

// Function to show the popup if the cookie is not set
function showPopup() {
    const popup = document.getElementById('guidePopup');
    const body = document.documentElement;

    if (!popup) {
        return;
    }

    // Function to check if the clicked element is inside the popup
    function isClickInsidePopup(event) {
        return popup.contains(event.target);
    }

    // Event listener to handle the click event
    function handlePopupClick(event) {
        // Check if the clicked element is inside the popup
        if (isClickInsidePopup(event)) {
            // Handle button click inside the popup if needed
            const clickedButton = event.target.closest('button');
        } else {
            document.querySelector('.body-overlay').onclick = function() {
                // Clicked outside the popup, remove classes and set the cookie
                popup.classList.remove('active');
                body.classList.remove('guide-open');
                setCookie('guide-shown', 'true', 2);
                //setCookie("guide-shown", "true", 180);

                // Remove event listeners after handling the click
                document.removeEventListener('click', handlePopupClick);
                document.removeEventListener('keydown', handleEscapeKey);
            };
        }
    }

    // Event listener to handle the 'Escape' key
    function handleEscapeKey(event) {
        if (event.key === 'Escape') {
            // Remove classes and set the cookie on 'Escape' key press
            popup.classList.remove('active');
            body.classList.remove('guide-open');
            //setCookie('guide-shown', 'true', 2);
            setCookie('guide-shown', 'true', 180);

            // Remove event listeners after handling the 'Escape' key
            document.removeEventListener('click', handlePopupClick);
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }

    // Show the popup
    if (getCookie('guide-shown') === '') {
        popup.classList.add('active');
        body.classList.add('guide-open');
        document.addEventListener('click', handlePopupClick);
        document.addEventListener('keydown', handleEscapeKey);
    }
}

// Function to close the popup
function closePopup() {
    const popup = document.getElementById('guidePopup');
    const body = document.documentElement;
    if (!popup) {
        return;
    }

    popup.classList.remove('active');
    body.classList.remove('guide-open');

    setCookie('guide-shown', 'true', 2);
}

// Call the showPopup function when the page loads
window.onload = showPopup;

//# sourceMappingURL=start-guide.js.map
